import type { UploadPolicy } from "@nexus/contracts";

const EXTENSION_TO_CONTENT_TYPE: Record<string, string> = {
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

/** Browsers sometimes omit `File.type`; infer from extension when the policy allows it. */
export function resolveCustomAssetContentType(file: File, policy: UploadPolicy): string {
  const declared = file.type.trim();
  if (declared && policy.allowedContentTypes.includes(declared)) {
    return declared;
  }

  const extension = file.name.split(".").pop()?.toLowerCase();
  if (!extension) return declared;

  const inferred = EXTENSION_TO_CONTENT_TYPE[extension];
  if (inferred && policy.allowedContentTypes.includes(inferred)) {
    return inferred;
  }

  return declared;
}
